import { useEffect, useState } from "react";

// STYLES
import * as Style from "./ReportsStyle";

// LIBRARIES

// MISC
import { Tabs } from "models/GeneralTypes/generalTypes";
import {
  IFilters,
  IRentalApiParams,
  IUsersApiParams, RentalsTableData,
  UsersTableData
} from "models/interfaces";

// ASSETS

// REDUX
import { getAllRentals } from "api/rentalApi";
import { getAllUsers } from "api/userApi";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  rentalFilters,
  rentalsData,
  rentalTotalPages,
  toggleClearRentalsTableData
} from "slices/rentalSlice";
import {
  language,
  selectedTab, toggleActiveTab, toggleReportsTabs
} from "slices/uiSlice";
import {
  toggleClearUsersTableData,
  usersData,
  usersFilters,
  userTotalPages
} from "slices/userSlice";

// COMPONENTS
import FiltersComponent from "components/FiltersComponent/FiltersComponent";
import DynamicTable from "components/Table/Table";
import TabsComponent from "components/Tabs/Tabs";
import { filters, handleResetFiltersState } from "slices/filtersSlice";
import moment from "moment";

const Reports = () => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const rentalsTableDatas = useAppSelector<RentalsTableData[]>(rentalsData);
  const usersTableDatas = useAppSelector<UsersTableData[]>(usersData);
  const rentalTotalPage = useAppSelector<number>(rentalTotalPages);
  const userTotalPage = useAppSelector<number>(userTotalPages);
  const usersFiltersValue = useAppSelector<IUsersApiParams>(usersFilters);
  const rentalFiltersValue = useAppSelector<IRentalApiParams>(rentalFilters);
  const selectedLanguage = useAppSelector<string>(language);
  const activeTab = useAppSelector<string>(selectedTab);
  const filtersData = useAppSelector<IFilters>(filters);

  // CONSTANTS USING HOOKS
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    dispatch(toggleReportsTabs());
    dispatch(toggleActiveTab(Tabs.RENTALS));
    // dispatch(handleResetFiltersState());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setIsLoading(true);
    if (activeTab === Tabs.RENTALS) {
      let payload: IRentalApiParams = {
        userFullName: {
          usernameOrPhoneNumber: filtersData.searchBarValue
        },
        lockerId: filtersData.lockerSelectValue,
        startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
        endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
        page: String(filtersData.page)
      }
      dispatch(getAllRentals(payload))
        .unwrap()
        .then(() => {
          dispatch(toggleClearUsersTableData());
          setIsLoading(false);
        });
    } else if (activeTab === Tabs.USERS) {
      let payload: IUsersApiParams = {
        fullName: {
          usernameOrPhoneNumber: filtersData.searchBarValue
        },
        userStatus: filtersData.statusTypeValue,
        startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
        endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
        page: String(filtersData.page)
      }
      dispatch(getAllUsers(payload))
        .unwrap()
        .then(() => {
          dispatch(toggleClearRentalsTableData());
          setIsLoading(false);
        });
    }
    // eslint-disable-next-line
  }, [activeTab, usersFiltersValue, rentalFiltersValue, selectedLanguage]);
  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  return (
    <Style.ReportsContainer>
      <FiltersComponent />
      {!isLoading ?
        <>
          {rentalsTableDatas &&
            <DynamicTable
              totalPages={rentalTotalPage}
              tableData={rentalsTableDatas}
            />
          }
          {usersTableDatas &&
            <DynamicTable
              totalPages={userTotalPage}
              tableData={usersTableDatas}
            />
          }
        </> : <Style.LodingSign />
      }
    </Style.ReportsContainer>
  );
};

export default Reports;
